import { render, staticRenderFns } from "./database.vue?vue&type=template&id=cf6cb61e&scoped=true&"
import script from "./database.vue?vue&type=script&lang=js&"
export * from "./database.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6cb61e",
  null
  
)

export default component.exports